// extracted by mini-css-extract-plugin
module.exports = {"styles":"_6rV5AqYtxmiKb0D6Ifbg3"};